import { t } from './i18n/i18n';

/**
 * The premium currency is written as the WORD "Delta-V" wherever it labels a price or an amount, never as the old
 * rocket glyph. `size` picks the context: `sm` beside a figure, `md` under a headline number, `lg` as a standalone mark.
 */
export function deltaVWordHtml(size: 'sm' | 'md' | 'lg' = 'sm'): string {
  return `<span class="dv-word dv-word--${size}">${t('term.deltaV')}</span>`;
}
